export default class VttError {
    public message: string;
    public hasError: boolean;
  
    constructor() {
      this.message = "";
      this.hasError = false;
    }
  }


// WEBPACK FOOTER //
// ./src/api/vttError.ts